/* eslint-disable react/prop-types */
import classes from "./request-ok.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import Label from "@/components-library/widgets/label";
function RequestOk({ onBackToHomeClick }) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="center"
      className={classes.container}
    >
      <img
        src="/images/software/PROSSIMITI-icon-Check.svg"
        alt="Logo"
        className={classes.icon}
      />

      <Label
        weight="bold"
        tag="h2"
        color="secondary"
        align="start"
        className={classes.title}
      >
        Grazie per averci contattato!
      </Label>

      <Label
        weight="bold"
        tag="h5"
        color="secondary"
        align="center"
        className={classes.subTitle}
      >
        Sarai ricontatto entro due giorni lavorativi
      </Label>

      <Button
        size="sm"
        color="primary"
        className={classes.button}
        onClick={onBackToHomeClick}
      >
        TORNA ALLA HOME
      </Button>
    </Flex>
  );
}

export default RequestOk;
